module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/hero-dd49de8de14b749d7ba341feaee9dd85.jpg";